import React, { useState } from "react";

interface Props {
  title: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
}

export default function CollapsibleSection({ title, defaultOpen = true, children }: Props) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="border-b border-[#EEF1F4]">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex justify-between items-center py-4 cursor-pointer select-none"
      >
        <div className="text-[16px] font-bold text-ink">{title}</div>
        <span className={`w-[10px] h-[10px] border-r-2 border-b-2 border-ink2 transition-transform ${open ? "rotate-45 -mt-[6px]" : "-rotate-45 mt-[2px]"}`} />
      </button>
      {open && <div className="pb-4">{children}</div>}
    </div>
  );
}